module.exports = __webpack_public_path__ + "img/suw_logo.bd91c79f.png";